import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { CapturumCheckboxComponent } from '@capturum/ui/checkbox';
import { ManageValidatorDisplayDirective } from '@features/client/form-builder/directives/hide-validator.directive';
import { ReactiveFormsModule } from '@angular/forms';
import { HideFromSummaryPdfDirective } from '@features/client/order-workflow/directives/hide-from-summary-pdf.directive';
import { Tooltip } from 'primeng/tooltip';

@Component({
  selector: 'app-checkbox-input',
  templateUrl: './checkbox-input.component.html',
  styleUrls: ['./checkbox-input.component.scss'],
  imports: [
    CapturumCheckboxComponent,
    ManageValidatorDisplayDirective,
    ReactiveFormsModule,
    HideFromSummaryPdfDirective,
    Tooltip,
  ],
})
export class CheckboxInputComponent extends FieldType {}
